Shopware.Component.register('swag-cms-extensions-custom-form-element', import('./component'));
Shopware.Component.register('swag-cms-extensions-custom-form-element-config', () => import('./config'));
Shopware.Component.register('swag-cms-extensions-custom-form-element-preview', () => import('./preview'));

Shopware.Service('cmsService').registerCmsElement({
    name: 'custom-form',
    category: 'form',
    label: 'swag-cms-extensions.sw-cms.elements.custom-form.label',
    component: 'swag-cms-extensions-custom-form-element',
    configComponent: 'swag-cms-extensions-custom-form-element-config',
    previewComponent: 'swag-cms-extensions-custom-form-element-preview',
    defaultConfig: {
        type: {
            source: 'static',
            value: 'custom-form',
        },
    },
});
